
import convertUnit from '@/utils/convertUnit';
import Vue from 'vue'
import UserProvisioning from '@/mixins/userProvisioning';
// import GeneralScopeofWork from "../../../components/GeneralScopeofWorkSheet"
export default Vue.extend({
    components:{
        // 'general-scope-work':GeneralScopeofWork
    },
    mixins: [UserProvisioning],
    props:{
        projectId:{
            default:-1
        },
        operationUnitId:{default:-1},
        sequenceId:{default:-1},
        selectedOperationUnitName:{
            default:""
        },
        readOnlyView:{
            type:Boolean
        }
    },
    data(){
        return {
            northing:0,
            easting:0,
            location:"0,0",
            activeView:1,
            objective:"",
            estimatedProduction:0,
            totalDepthTVDss: 0,
            totalDepthMD: 0,
            waterDepth: 0,
            depthReference: 0,
            depthReferenceType: "",
            unitSystem: "",
            expectedGasRate: 0,
            expectedOilRate: 0,
            expectedCondensateRate: 0,
            useTarget: false,
            targets:[],
            isLoading: false,
            hasError: false,
            active_target: {},
            isViewingTargetList: true,
            targetFields:[
                {
                    key:"name",
                    label:"Reservoir Name"
                },
                {
                    key:"easting",
                    label:"Easting(m)"
                },
                {
                    key:"northing",
                    label:"Northing(m)"
                },
                {
                    key:"depth",
                    label:"Target Depth(ft-SSTVD)"
                },
                {
                    key:"fluidType",
                    label:"Fluid Type"
                },
                {
                    key:"expectedRate",
                    label:"Expected Rate"
                },
                {
                    key:"actions",
                    label:"Actions"
                }
            ]
        }
    },
    methods:{
        onObjectiveChanged(newVal:any){
            this.$store.commit("projectModule/updateProject",{sequenceId:this.project.sequenceId,id:this.project.id,objective:newVal})
        },

        onTargetDepthChanged(){
            this.project.well.totalDepthTVDss.value = this.totalDepthTVDss;
            this.project.well.waterDepth.value = this.waterDepth;
            this.project.well.totalDepthMD.value = this.totalDepthMD;
            this.project.well.depthReference.value = this.depthReference;
            this.project.well.depthReferenceType = this.depthReferenceType;            
            this.project.well.location = `${this.northing}, ${this.easting}`;
            this.project.well.unitSystem = this.currentUnitSystem;
            this.location = `${this.northing}, ${this.easting}`;
            this.project.well.expectedOilRate = this.expectedOilRate;
            this.project.well.expectedGasRate = this.expectedGasRate;
            this.project.well.expectedCondensateRate = this.expectedCondensateRate;
            this.project.well.useTarget = this.useTarget;

            const well = {
                wellName: this.project.well.name,
                wellId: this.project.well.wellId,
                leaseId: this.project.well.leaseId,
                fluidType: this.project.well.wellType,
                field: this.project.well.field,
                terrain: this.project.well.terrain,
                unitSystem: this.currentUnitSystem,
                totalDepthTVDss: this.project.well.totalDepthTVDss.value,
                totalDepthMD: this.project.well.totalDepthMD.value,
                waterDepth: this.project.well.waterDepth.value,
                depthReference: this.project.well.depthReference.value,
                depthReferenceType: this.project.well.depthReferenceType,
                location: this.project.well.location,
                expectedOilRate: this.project.well.expectedOilRate,
                expectedGasRate: this.project.well.expectedGasRate,
                expectedCondensateRate: this.project.well.expectedCondensateRate,
                useTarget: this.project.well.useTarget,
                id: this.project.well.id,
                link: this.project.well.link
            }

            try {
                this.$store.dispatch('wellsModule/updateWellAction', well)
                this.$bvToast.toast('Well Saved Successfully', {
                    title: 'Success',
                    autoHideDelay: 2000,
                    appendToast: true,
                    solid: true,
                    variant: 'success',
                })
            } catch (error) {
                this.$bvToast.toast('Unable to Save Well', {
                    title: 'Error',
                    autoHideDelay: 2000,
                    appendToast: true,
                    solid: true,
                    variant: 'danger',
                })
            }
        },

        onEstimatedProductionChanged(newVal:any){
            if(newVal==""){
                this.$store.commit("projectModule/updateProject",{sequenceId:this.project.sequenceId,id:this.project.id,estimatedProduction:0})
            }else{
                this.$store.commit("projectModule/updateProject",{sequenceId:this.project.sequenceId,id:this.project.id,estimatedProduction:newVal})
            }
        },

        gotoNext(){
            if(this.activeView<=1){
                this.activeView++
            }
        },

        gotoPrevious(){
            if(this.activeView>1)this.activeView--
        },

        addTarget(){
            let target = {
                id:"",
                name:"",
                northing:0,
                easting:0,
                depth:0,
                fluidType: "Oil",
                expectedRate:0
            }
            this.$store.commit("projectModule/addOrUpdateTargetToProject",{sequenceId:this.project.sequenceId,id:this.project.id,target})
        },
        removeTarget(target:any){
            this.$store.commit("projectModule/deleteTargetInProject",{sequenceId:this.project.sequenceId,id:this.project.id,target})
        },
        registerProjectChange(){
            this.$store.commit("projectModule/registerProjectChange",{sequenceId:this.project.sequenceId,projectId:this.project.id})
        },
        getRateLabel(fluidType: string) {
            switch (fluidType) {
                case 'Oil':
                    return 'BOPD';
                case 'Gas':
                    return 'MMSCF/D';
                case 'Water':
                    return 'BOPD';
                case 'Condensate':
                    return 'BOPD';
                default:
                    return '';
            }
        },
        getRatePlaceholder(fluidType: string) {
            switch (fluidType) {
                case 'Oil':
                    return 'Enter BOPD';
                case 'Gas':
                    return 'Enter MMSCF/D';
                case 'Water':
                    return 'Enter BOPD';
                case 'Condensate':
                    return 'Enter BOPD';
                default:
                    return 'Enter rate';
            }
        }
    },
    computed:{
        project():any{
            return this.$store.getters['projectModule/getProjectById'](this.projectId)
        },
        settingswellFluid():Array<any> {
            return this.$store.getters['settingsModule/getSettingsWell']
        },
        fetchColorSettings():any {
            return this.$store.dispatch('settingsModule/getColorSettings')
        },
        getWellFluidType():Array<any> {
            let wellTypeOptions: Array<any>=[]
            this.settingswellFluid.forEach((wellType: any)=>{
                wellTypeOptions.push({text:wellType.propertyName,value:wellType.propertyName})
            })
            return wellTypeOptions
        },
        currentUnitSystem():any {
            return this.$store.getters['UnitsModule/getCurrentUnitSystem']
        },
        currentSystem ():any {
            return this.$store.getters['UnitsModule/getCurrentUnitSystem']
        }
    },
    watch:{
        project:{
            immediate:true,
            handler(){
                this.estimatedProduction = this.project.estimatedProduction
                this.objective = this.project.objective
                this.totalDepthTVDss = this.project.well.totalDepthTVDss && this.project.well.totalDepthTVDss.value > 0 
                    ? convertUnit(this.project.well.totalDepthTVDss.value, this.currentUnitSystem, this.project.well.unitSystem.toLowerCase() === 'field' ? 'ft' : 'm')
                    : 0
                this.totalDepthMD = this.project.well.totalDepthMD && this.project.well.totalDepthMD.value > 0 
                    ? convertUnit(this.project.well.totalDepthMD.value, this.currentUnitSystem, this.project.well.unitSystem.toLowerCase() === 'field' ? 'ft' : 'm')
                    : 0
                this.waterDepth = this.project.well.waterDepth && this.project.well.waterDepth.value > 0 
                    ? convertUnit(this.project.well.waterDepth.value, this.currentUnitSystem, this.project.well.unitSystem.toLowerCase() === 'field' ? 'ft' : 'm')
                    : 0
                this.depthReference = this.project.well.depthReference && this.project.well.depthReference.value > 0 
                    ? convertUnit(this.project.well.depthReference.value, this.currentUnitSystem, this.project.well.unitSystem.toLowerCase() === 'field' ? 'ft' : 'm')
                    : 0
                this.northing = this.project.well.location && this.project.well.location !== ',' ? this.project.well.location.split(',')[0] : '0'
                this.easting = this.project.well.location && this.project.well.location !== ',' ? this.project.well.location.split(',')[1] : '0'
                this.location = this.project.well.location && this.project.well.location !== ',' ? this.project.well.location : `${this.northing}, ${this.easting}`
                this.depthReferenceType = this.project.well.depthReferenceType && this.project.well.depthReferenceType !== '' ? this.project.well.depthReferenceType : '';
                this.expectedOilRate = this.project.well.expectedOilRate;
                this.expectedGasRate = this.project.well.expectedGasRate;
                this.expectedCondensateRate = this.project.well.expectedCondensateRate;
                this.useTarget = this.project.well.useTarget;
                if(this.project.targets == null){
                    this.project.targets = []
                }else{
                    this.project.targets = this.project.targets.map((t:any)=>({
                        id: t.id, 
                        name: t.name, 
                        northing: t.northing, 
                        easting: t.easting, 
                        depth: t.depth, 
                        fluidType: t.fluidType || 'Oil',
                        expectedRate: t.expectedRate || 0
                    }))
                }
            }
        }
    },
    created() {
        if (this.settingswellFluid.length < 1)
            this.fetchColorSettings.then(() => {});
    },
})
